@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.footer {
  @include sm-sohne;
  margin-left: calc(var(--collab-item-avatar-size) + var(--collab-item-avatar-gap));
  margin-top: 10px;
  color: var(--dark-40);

  [data-autopilot-system-redesign='on'] & {
    @include xs-sohne-book;
  }

  &.hasChildren {
    margin-top: 6px;

    @include for-phone-only {
      margin-top: 12px;
    }
  }
}
